import { render, staticRenderFns } from "./ModalMensagem.vue?vue&type=template&id=c033c0b2&scoped=true"
import script from "./ModalMensagem.vue?vue&type=script&lang=js"
export * from "./ModalMensagem.vue?vue&type=script&lang=js"
import style0 from "./ModalMensagem.vue?vue&type=style&index=0&id=c033c0b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c033c0b2",
  null
  
)

export default component.exports